import { useUser } from 'stores/userStore';
import { findOwnedUserEntity, findFollowingUserEntity, isOwned, isFavorite } from 'actions/user_entities_actions';
import { followEntity, unfollowEntity, useUserEntities } from 'stores/userEntitiesStore';
import Star from '../../icons/Star';
import { FollowableEntityType } from 'queries';
import { useApplicationContainer } from 'containers/ApplicationContainer';
import Button, { ButtonProps, ButtonSize } from '@/components/Button';

type FollowButtonProps = ButtonProps & {
  entityType?: FollowableEntityType;
  entityId: string;
};

export default function FollowButton({ entityType = FollowableEntityType.Team, entityId, ...props }: FollowButtonProps) {
  const user = useUser();
  const userEntities = useUserEntities();
  const [, { handleOpenLoginModal }] = useApplicationContainer();

  if (!user.isResolved || (user.isLoggedIn && !userEntities.isResolved)) {
    return null;
  }

  const ownedUserEntity = findOwnedUserEntity(userEntities.userEntities, entityType, entityId);
  const isOwner = !!ownedUserEntity && isOwned(ownedUserEntity);
  const followingUserEntity = findFollowingUserEntity(userEntities.userEntities, entityType, entityId);
  const isFollowing = !!followingUserEntity && isFavorite(followingUserEntity);

  function handleClick() {
    if (isOwner) return;

    if (!user.isLoggedIn) {
      handleOpenLoginModal();
    } else if (isFollowing) {
      unfollowEntity(followingUserEntity);
    } else {
      followEntity(entityType, entityId);
    }
  }

  return (
    <Button size={ButtonSize.SMALL} {...props} onClick={handleClick}>
      {isOwner && 'Owned'}
      {isFollowing && 'Following'}
      {!isOwner && !isFollowing && (
        <>
          <Star color="#fff" height={12} width={12} />
          Follow
        </>
      )}
    </Button>
  );
}
